import { API_ORDER } from '../../order'
import { API_SHIPPING } from '../../shipping'

export async function fetchPaymentId(orderCode: string): Promise<string | void> {
    let paymentId

    try {
        const {
            defaultShippingAddress: shippingAddress,
        } = await API_ORDER.fetchOrderDefaultShippingAddress(orderCode)
        const shippingMethods = await API_SHIPPING.fetchShippingMethods(
            orderCode,
            shippingAddress
        )
        const { methodID } = shippingMethods[0]

        await API_SHIPPING.createShipping(orderCode, { methodID, fields: {} })
    } catch (error) {
        if (error.data?.errorDetails?.paymentID) paymentId = error.data.errorDetails.paymentID
    }

    return paymentId
}
